import { getDefaultCurrentFilters } from './getDefaultCurrentFilters';
import {
    allFilterText,
    appointmentsFilterText,
    organizerFilterText,
    attendeeFilterText,
    acceptedFilterText,
} from 'owa-calendar-shared-strings/lib/strings/calendarSurfaceCommandBar.locstring.json';
import { logUsage } from 'owa-analytics';
import { CalendarEventsFilters } from './CalendarEventsFilters';
import { removeFilter } from '../actions/removeFilter';
import { addFilter } from '../actions/addFilter';

export const filterOnClick = (filterKey: string): void => {
    if (filterKey == undefined) {
        return;
    }
    var currentFilters = getDefaultCurrentFilters();
    const filterSelected: boolean = currentFilters.includes(filterKey);
    if (filterSelected) {
        removeFilter(filterKey, currentFilters);
    } else {
        addFilter(filterKey, currentFilters);
        const isCategory = isCategoryFilter(filterKey);
        logUsage('CalendarEventsFilterSelected', {
            isCategoryFilter: isCategory,
            filterName: isCategory ? 'Category' : filterKey,
        });
    }
};

function isCategoryFilter(filterKey: string) {
    const nonCategoryFilters = [
        allFilterText,
        appointmentsFilterText,
        organizerFilterText,
        attendeeFilterText,
        acceptedFilterText,
    ];
    if (nonCategoryFilters.includes(filterKey)) {
        return false;
    }
    return true;
}

export const allFilterOnClick = (): void => {
    const currentFilters = getDefaultCurrentFilters();
    if (currentFilters == [CalendarEventsFilters.All]) {
        return;
    }
    addFilter(CalendarEventsFilters.All, [CalendarEventsFilters.All]);
    logUsage('CalendarEventsFilterSelected', {
        isCategoryFilter: false,
        filterName: allFilterText,
    });
};
